<div style="max-height: 70vh; overflow-y: auto;">
  @if (data.template.description) {
    <p nz-typography style="margin-bottom: 16px; color: #8c8c8c;">
      {{ data.template.description }}
    </p>
    <nz-divider></nz-divider>
  }

  <nz-collapse [nzBordered]="false">
    @if (data.template.content.icd10Id || data.template.content.icd102Id || data.template.content.illness) {
      <nz-collapse-panel nzHeader="დასკვნითი დიაგნოზი" [nzActive]="true">
        <nz-card nzSize="small" style="margin-bottom: 8px;">
          @if (getIcdName(data.template.content.icd10Id); as icd10Name) {
            <div style="margin-bottom: 12px;">
              <strong>ICD-10 დიაგნოზი:</strong>
              <div style="margin-top: 4px; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
                {{ icd10Name }}
              </div>
            </div>
          }
          @if (getIcdName(data.template.content.icd102Id); as icd102Name) {
            <div style="margin-bottom: 12px;">
              <strong>ICD-10 დიაგნოზი 2:</strong>
              <div style="margin-top: 4px; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
                {{ icd102Name }}
              </div>
            </div>
          }
          @if (data.template.content.illness) {
            <p><strong>დაავადების ხასიათი:</strong> {{ getIllnessType(data.template.content.illness) }}</p>
          }
        </nz-card>
      </nz-collapse-panel>
    }

    @if (data.template.content.diseaseComplications && data.template.content.diseaseComplications.length > 0) {
      <nz-collapse-panel nzHeader="დაავადების გართულება">
        @for (complication of data.template.content.diseaseComplications; track $index) {
          <nz-card nzSize="small" style="margin-bottom: 8px;">
            @if (getIcdName(complication.icd10Id); as icdName) {
              <p><strong>ICD-10:</strong> {{ icdName }}</p>
            }
            @if (complication.illness) {
              <p><strong>დაავადების ხასიათი:</strong> {{ getIllnessType(complication.illness) }}</p>
            }
          </nz-card>
        }
      </nz-collapse-panel>
    }

    @if (data.template.content.accompanyingDisease && data.template.content.accompanyingDisease.length > 0) {
      <nz-collapse-panel nzHeader="თანმხლები დაავადება">
        @for (disease of data.template.content.accompanyingDisease; track $index) {
          <nz-card nzSize="small" style="margin-bottom: 8px;">
            @if (getIcdName(disease.icd10Id); as icdName) {
              <div style="margin-bottom: 8px;">
                <strong>ICD-10:</strong> {{ icdName }}
              </div>
            }
            @if (getIcdName(disease.icd102Id); as icd102Name) {
              <div style="margin-bottom: 8px;">
                <strong>ICD-10 (2):</strong> {{ icd102Name }}
              </div>
            }
            @if (disease.illness) {
              <p><strong>დაავადების ხასიათი:</strong> {{ getIllnessType(disease.illness) }}</p>
            }
          </nz-card>
        }
      </nz-collapse-panel>
    }

    @if (data.template.content.simptoms || data.template.content.diseaseAnamnesis || data.template.content.objectiveExaminations) {
      <nz-collapse-panel nzHeader="ზოგადი ინფორმაცია" [nzActive]="true">
        <nz-card nzSize="small" style="margin-bottom: 8px;">
          @if (data.template.content.typeOfHospitalization) {
            <p><strong>ჰოსპიტალიზაციის ტიპი:</strong> {{ data.template.content.typeOfHospitalization }}</p>
          }
          @if (data.template.content.simptoms) {
            <p><strong>სიმპტომები:</strong> {{ data.template.content.simptoms }}</p>
          }
          @if (data.template.content.diseaseAnamnesis) {
            <p><strong>დაავადების ანამნეზი:</strong> {{ data.template.content.diseaseAnamnesis }}</p>
          }
          @if (data.template.content.objectiveExaminations) {
            <p><strong>ობიექტური გამოკვლევები:</strong> {{ data.template.content.objectiveExaminations }}</p>
          }
        </nz-card>
      </nz-collapse-panel>
    }

    @if (data.template.content.treatmentRecords && data.template.content.treatmentRecords.length > 0) {
      <nz-collapse-panel nzHeader="მკურნალობის ჩანაწერები" [nzActive]="true">
        @for (record of data.template.content.treatmentRecords; track $index) {
          <nz-card nzSize="small" [nzTitle]="getTreatmentTypeLabel(record.type)" style="margin-bottom: 8px;">
            @if (record.ncsp) {
              <p><strong>NCSP:</strong> {{ record.ncsp.title }}</p>
            }
            @if (record.icd10) {
              <p><strong>ICD-10:</strong> {{ record.icd10.title }}</p>
            }
            @if (record.procedureResult) {
              <p><strong>პროცედურის შედეგი:</strong> {{ record.procedureResult }}</p>
            }
            @if (record.labExamText) {
              <p><strong>ლაბორატორიული გამოკვლევა:</strong> {{ record.labExamText }}</p>
            }
            @if (record.drugName) {
              <p><strong>მედიკამენტი:</strong> {{ record.drugName }}</p>
            }
            @if (record.consultantName) {
              <p><strong>კონსულტანტი:</strong> {{ record.consultantName }}</p>
            }
            @if (record.consultationComment) {
              <p><strong>კონსულტაციის კომენტარი:</strong> {{ record.consultationComment }}</p>
            }
            @if (record.bloodComponent) {
              <p><strong>სისხლის კომპონენტი:</strong> {{ getBloodComponentLabel(record.bloodComponent) }}</p>
            }
            @if (record.indicationOfTransfusion) {
              <p><strong>გადასხმის ინდიკაცია:</strong> {{ record.indicationOfTransfusion }}</p>
            }
            @if (record.quantity) {
              <p><strong>რაოდენობა:</strong> {{ record.quantity }}</p>
            }
            @if (record.transfusionComment) {
              <p><strong>გადასხმის კომენტარი:</strong> {{ record.transfusionComment }}</p>
            }
            @if (record.anesthesiaComment) {
              <p><strong>ანესთეზიის კომენტარი:</strong> {{ record.anesthesiaComment }}</p>
            }
            @if (record.protocolText) {
              <p><strong>ოქმის ტექსტი:</strong> {{ record.protocolText }}</p>
            }
          </nz-card>
        }
      </nz-collapse-panel>
    }

    @if (data.template.content.recommendations && data.template.content.recommendations.length > 0) {
      <nz-collapse-panel nzHeader="რეკომენდაციები">
        @for (recommendation of data.template.content.recommendations; track $index) {
          <nz-card nzSize="small" [nzTitle]="getRecommendationType(recommendation.type)" style="margin-bottom: 8px;">
            @if (recommendation.ncsp) {
              <p><strong>NCSP:</strong> {{ recommendation.ncsp.title }}</p>
            }
            @if (recommendation.icd10) {
              <p><strong>ICD-10:</strong> {{ recommendation.icd10.title }}</p>
            }
            @if (recommendation.recommendation) {
              <p><strong>რეკომენდაცია:</strong> {{ recommendation.recommendation }}</p>
            }
            @if (recommendation.doctorComment) {
              <p><strong>ექიმის კომენტარი:</strong> {{ recommendation.doctorComment }}</p>
            }
            @if (recommendation.ncspComment) {
              <p><strong>NCSP კომენტარი:</strong> {{ recommendation.ncspComment }}</p>
            }
            @if (recommendation.icd10Comment) {
              <p><strong>ICD-10 კომენტარი:</strong> {{ recommendation.icd10Comment }}</p>
            }
            @if (recommendation.deadline) {
              <p><strong>ვადა:</strong> {{ recommendation.deadline }}</p>
            }
            @if (recommendation.instrumentalExplorationsDate) {
              <p><strong>ინსტრუმენტული გამოკვლევის თარიღი:</strong> {{ recommendation.instrumentalExplorationsDate }}</p>
            }
          </nz-card>
        }
      </nz-collapse-panel>
    }

    @if (data.template.content.prescriptions && data.template.content.prescriptions.length > 0) {
      <nz-collapse-panel nzHeader="პრესკრიფციები (ERX)">
        @for (prescription of data.template.content.prescriptions; track $index) {
          <nz-card nzSize="small" style="margin-bottom: 8px;">
            <div style="margin-bottom: 12px; padding: 8px; background-color: #f0f5ff; border-radius: 4px;">
              <strong style="font-size: 14px;">{{ prescription.productName || prescription.product?.geoTradeName }}</strong>
              @if (prescription.product?.engTradeName) {
                <div style="font-size: 12px; color: #8c8c8c; margin-top: 2px;">
                  {{ prescription.product.engTradeName }}
                </div>
              }
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 8px;">
              @if (prescription.prodCount) {
                <div>
                  <strong>რაოდენობა:</strong> {{ prescription.prodCount }}
                </div>
              }
              @if (prescription.duration) {
                <div>
                  <strong>ხანგრძლივობა:</strong> {{ prescription.duration }} დღე
                </div>
              }
            </div>

            @if (prescription.ds) {
              <div style="margin-bottom: 8px;">
                <strong>დოზირება:</strong>
                <div style="margin-top: 4px; padding: 6px; background-color: #fafafa; border-radius: 4px;">
                  {{ prescription.ds }}
                </div>
              </div>
            }

            <div style="display: flex; gap: 16px; margin-top: 8px; flex-wrap: wrap;">
              @if (prescription.isGeneric !== undefined) {
                <div style="padding: 4px 8px; background-color: {{ prescription.isGeneric ? '#f6ffed' : '#fff7e6' }}; border-radius: 4px; font-size: 12px;">
                  {{ prescription.isGeneric ? '✓ გენერიული' : '○ არა-გენერიული' }}
                </div>
              }
              @if (prescription.dosagePriv) {
                <div style="padding: 4px 8px; background-color: #fff1f0; border-radius: 4px; font-size: 12px;">
                  დოზირების პრივილეგია
                </div>
              }
              @if (prescription.isCopy) {
                <div style="padding: 4px 8px; background-color: #e6f7ff; border-radius: 4px; font-size: 12px;">
                  ასლი
                </div>
              }
            </div>

            @if (prescription.product) {
              <nz-divider style="margin: 12px 0;"></nz-divider>
              <div style="font-size: 12px; color: #595959;">
                @if (prescription.product.manufacturer) {
                  <p style="margin: 4px 0;"><strong>მწარმოებელი:</strong> {{ prescription.product.manufacturer }}</p>
                }
                @if (prescription.product.manufacturerCountryName) {
                  <p style="margin: 4px 0;"><strong>ქვეყანა:</strong> {{ prescription.product.manufacturerCountryName }}</p>
                }
                @if (prescription.product.pharmaTherapyGroup) {
                  <p style="margin: 4px 0;"><strong>ფარმაკოთერაპიული ჯგუფი:</strong> {{ prescription.product.pharmaTherapyGroup }}</p>
                }
                @if (prescription.product.issuanceMode) {
                  <p style="margin: 4px 0;"><strong>გაცემის რეჟიმი:</strong> {{ prescription.product.issuanceMode }}</p>
                }
                @if (prescription.product.otherDetailsGeo) {
                  <p style="margin: 4px 0;"><strong>დეტალები:</strong> {{ prescription.product.otherDetailsGeo }}</p>
                }
              </div>
            }
          </nz-card>
        }
      </nz-collapse-panel>
    }

    @if (data.template.content.questionnaires) {
      <nz-collapse-panel nzHeader="კითხვარი">
        <nz-card nzSize="small">
          <p><strong>კითხვარის სახელი:</strong> {{ data.template.content.questionnaires.name }}</p>
          @if (data.template.content.questionnaires.fields && data.template.content.questionnaires.fields.length > 0) {
            <p style="margin-bottom: 12px;"><strong>ველების რაოდენობა:</strong> {{ data.template.content.questionnaires.fields.length }}</p>

            <nz-divider style="margin: 12px 0;"></nz-divider>

            <div style="margin-top: 12px;">
              <strong>ველები:</strong>
              <div style="margin-top: 8px;">
                @for (field of data.template.content.questionnaires.fields; track field.id) {
                  <div style="padding: 8px; margin-bottom: 8px; background-color: #fafafa; border-radius: 4px; border-left: 3px solid #1890ff;">
                    <div style="font-weight: 500; margin-bottom: 4px;">
                      {{ field.label }}
                      @if (field.required) {
                        <span style="color: #ff4d4f; margin-left: 4px;">*</span>
                      }
                    </div>
                    <div style="font-size: 12px; color: #8c8c8c;">
                      ტიპი: {{ getFieldTypeLabel(field.type) }}
                      @if (field.multiple) {
                        | მრავალჯერადი არჩევანი
                      }
                    </div>
                    @if (field.options && field.options.length > 0) {
                      <div style="font-size: 12px; color: #595959; margin-top: 4px;">
                        ვარიანტები: {{ field.options.length }}
                      </div>
                    }
                    @if (field.value && field.type === 'text') {
                      <div style="font-size: 12px; color: #595959; margin-top: 4px;">
                        არჩეული მნიშვნელობა: {{ field.value }}
                      </div>
                    }
                    @if (field.value && field.type === 'select'){
                      <div style="font-size: 12px; color: #595959; margin-top: 4px;">
                        არჩეული მნიშვნელობა: {{ getFieldOptionLabel(field.options, field.value) }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </nz-card>
      </nz-collapse-panel>
    }
  </nz-collapse>
</div>
